export default __webpack_public_path__ + "static/vector-gray-map-67a4676ada5bb40826465228c942b579.svg";